import ManagedPicker from 'application/Shared/Components/Pickers/Managed';
import { ManagementState } from 'application/Shared/Constants';
import i18n from 'i18n';
import React from 'react';

const { t } = i18n;

const filterableOptions = [
    {
        name: t('Common.unmanaged'),
        parameter: 'managementStage',
        render: (
            <ManagedPicker
                visualOnly
                shortLabel
                value={ManagementState.UnmanagedApplication}
            />
        ),
        value: ManagementState.UnmanagedApplication
    },
    {
        name: t('Common.managed'),
        parameter: 'managementStage',
        render: (
            <ManagedPicker
                visualOnly
                shortLabel
                value={ManagementState.ManagedApplication}
            />
        ),
        value: ManagementState.ManagedApplication
    }
];

const header = {
    filterable: true,
    filterableOneOption: true,
    filterableOptions,
    key: 'managementStage',
    name: 'Common.managed',
    sortable: true,
    sortableFieldType: 'string',
    sortableKey: 'managementStage',
    squish: true,
    tooltip: 'management_state',
    width: '10%'
};

export default header;
